import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
// import faker from 'faker';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend
);

const AreaChart = (props) => {
    const options = {
        responsive: true,
        plugins: {
            legend: null
        },
        scales: { y: { min: 0, max: 5, stepSize: 1, } }
    };

    const data = {
        labels: props.labels,
        datasets: [
            {
                fill: true,
                label: 'Rating',
                data: props.ratings,
                borderColor: 'rgb(53, 162, 235)',
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            },
        ],
    };
    return <Line options={options} data={data} />;
}

export default AreaChart
